export function resolveLanguageCode(localeCode: string) {
  switch (localeCode.toLowerCase()) {
    case 'nl-nl':
      return 'NL'
    case 'nl-be':
      return 'NL'
    case 'fr-be':
      return 'FR'
    case 'da-dk':
      return 'DA'
    case 'fr-fr':
      return 'FR'
    case 'sv-se':
      return 'SV'
    case 'en-gb':
      return 'EN'
    case 'de-de':
      return 'DE'
  }
}
